import React, { CSSProperties } from 'react';
import { VirtualizedTableLabelPlural } from 'components/VirtualizedTable/types';

interface OwnProps {
    style: CSSProperties;
    labelPlural: VirtualizedTableLabelPlural;
}

type Props = OwnProps;

export default class VirtualizedTableEmptyRow extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { style, labelPlural } = this.props;

        return (
            <div className="virtualized-table-row empty" style={style}>
                <div
                    className="virtualized-table-cell"
                    style={{
                        width: '100%',
                        textAlign: 'center'
                    }}
                >
                    <div className="virtualized-table-cell-inner">
                        {`There are no ${labelPlural || 'items'}.`}
                    </div>
                </div>
            </div>
        );
    }
}
